import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import { getDateWithLongMonth } from "src/utils/Date";
import styles from "./AssembliesDeadlines.module.css";
import { UI } from "@wwimmo/ui";
import { RootStoreContext } from "src/stores/RootStore";
import { useContext } from "react";

interface AssembliesDeadlinesProps {
    assemblyid: string;
}

const AssemblyDeadlines = (props: AssembliesDeadlinesProps) => {
    const { t } = useTranslation();
    const { assemblyStore } = useContext(RootStoreContext);

    let eventDate: string | undefined;
    let motiondeadline = undefined;
    if (assemblyStore.currentAssembly && assemblyStore.currentAssembly.motiondeadline !== undefined) {
        motiondeadline = getDateWithLongMonth(assemblyStore.currentAssembly.motiondeadline);
    }
    if (assemblyStore.currentAssembly?.assemblyevents) {
        eventDate = getDateWithLongMonth(assemblyStore.currentAssembly.assemblyevents || "");
    } else {
        eventDate = undefined;
    }

    return (
        <UI.Card className={styles.AssemblyDeadlinesCard} title={t("screens.realestate.assembly.deadlines").toString()}>
            {eventDate ? (
                <div className={styles.EventData}>
                    <div className={styles.CardDetails}>{t("screens.realestate.assembly.deadlineAnnounced")}</div>
                    <UI.Row className={styles.CardValues}>
                        <div>{eventDate}</div>
                    </UI.Row>
                </div>
            ) : undefined}
            {motiondeadline ? (
                <>
                    <div className={styles.CardDetails}>{t("screens.realestate.assembly.motiondeadline")}</div>
                    <UI.Row className={styles.CardValues}>
                        <div>{motiondeadline}</div>
                    </UI.Row>
                </>
            ) : undefined}
        </UI.Card>
    );
};

export default observer(AssemblyDeadlines);
